import { AsyncPipe, NgClass, NgFor, NgIf } from '@angular/common';
import { NgModule } from '@angular/core';
import { ReactiveFormsModule } from '@angular/forms';
import { RouterLink } from '@angular/router';
import { SdAddCompanyButtonModule } from '@sdvor/company/ui';
import { CollapsibleTextComponent } from '@sdvor/shared/ui';
import { UrlModule } from '@spartacus/core';
import { SwitchProfileComponent } from './switch-profile.component';

@NgModule({
  imports: [
    NgIf,
    NgFor,
    NgClass,
    AsyncPipe,
    RouterLink,
    ReactiveFormsModule,
    SdAddCompanyButtonModule,
    UrlModule,
    CollapsibleTextComponent,
  ],
  exports: [SwitchProfileComponent],
  declarations: [SwitchProfileComponent],
})
export class SwitchProfileModule {}
